import mitt from "mitt";
import { dia } from "@clientio/rappid";

import { Message } from "./StatusBar/message";
import { Statechart } from "./Editor/mvc/statechart";
import { TextDiagnostic } from "./Editor/services/ui/text-diagnostic";
import { IdentifiableDiagnostic } from "./Editor/services/validation-service";
import { Step } from "vue3-tour";

type SimulationEvents = {
  stopSimulation: void;
};
export const SimulationEventBus = mitt<SimulationEvents>();

type UIEvents = {
  toolbarToggled: "simulation" | "edit";
  cellSelectionChanged: joint.mvc.Collection<dia.Cell>;
  editorValidated: TextDiagnostic[];
  updateView: "palette" | "properties" | "statechartDefinitions";
};
export const UIEventBus = mitt<UIEvents>();

export type ModelLoaded = {
  statechart: Statechart;
  source?: string | null;
};

type ModelEvents = {
  modelLoaded: ModelLoaded;
  modelChanged: void;
  prioritiesChanged: void;
  modelValidated: Array<IdentifiableDiagnostic>;
  modelIdCreated: void;
};
export const ModelEventBus = mitt<ModelEvents>();

type MessageEvents = {
  information: Message;
  warning: Message;
  error: Message;
  success: Message;
};
export const MessageEventBus = mitt<MessageEvents>();

type KeyEvents = {
  enter: Message;
  esc: Message;
};
export const KeyEventBus = mitt<KeyEvents>();

type TourEvents = {
  startOnboarding: Step[];
  stopOnboarding: void;
};

export const TourEventBus = mitt<TourEvents>();

type ProgressBarEvents = {
  startTask: {
    progress: number;
    notCancellableId: string;
  };
  finishedTask: string;
};

export const ProgressBarEventBus = mitt<ProgressBarEvents>();

type AbortRequestEvents = {
  abort: boolean;
};

export const AbortRequestEventBus = mitt<AbortRequestEvents>();

type WizardEvents = {
  forceSelectingStatechart: void;
  initialised: void;
};

export const WizardEventBus = mitt<WizardEvents>();
